export const BOOKSUBMIT = 'form/booksubmit';
export const REMOVEFLIGHT = 'form/removeflight';